import { render } from "./BsSpinner.vue?vue&type=template&id=2060d9fc"
const script = {}
script.render = render

export default script